module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "notification-modal",
      "height": "84",
      "pivot-y": .8,
      "adaptive": true,
      "width": 428
    },
    on: {
      "opened": _vm.opened,
      "before-close": _vm.beforeClose,
      "before-open": _vm.beforeOpen
    }
  }, [_c('div', {
    staticClass: "NotificationModal__container"
  }, [_c('div', {
    staticClass: "NotificationModal__text"
  }, [_vm._v("\n      " + _vm._s(_vm.text) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "NotificationModal__action",
    on: {
      "click": _vm.action
    }
  }, [_c('i', {
    staticClass: "icon-right-open"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3500be95","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/room/notification.modal/notification.modal.vue
// module id = 425
// module chunks = 1